

/// <reference path="StockNoteProductLine.ts" />

// Generated class WarehouseDeliveryNoteLine_ManagedObject

class WarehouseDeliveryNoteLine_ManagedObject extends StockNoteProductLine
{
}
